import React from 'react'
import { Outlet } from 'react-router-dom'

import { AppShell } from './AppShell'

import { ErrorPageNavbar, Footer } from 'components'

export const ExceptionLayout: React.FC = () => {
  return (
    <AppShell topBar={<ErrorPageNavbar />} footer={<Footer layout="public" />}>
      <Outlet />
    </AppShell>
  )
}
